// Avtalen som byrån godkänner när kontot läggs upp (ADR 0100): de allmänna
// villkoren och biträdesavtalet. Texterna finns i docs/avtal och visas på
// webbplatsen och i kontot. En ny version kräver ett nytt godkännande.

export const AGREEMENT_KINDS = ['terms', 'dpa'] as const;

export type AgreementKind = (typeof AGREEMENT_KINDS)[number];

export interface Agreement {
  /** Namnet som visas för byrån. */
  name: string;
  /** Datumet i texten, "Version 2026-10-09". */
  version: string;
  /** Sidan på webbplatsen och i kontot. */
  path: string;
  /** Filen i docs/avtal. */
  file: string;
}

export const AGREEMENTS: Record<AgreementKind, Agreement> = {
  terms: {
    name: 'Allmänna villkor',
    version: '2026-10-13',
    path: '/villkor',
    file: 'allmanna-villkor.md',
  },
  dpa: {
    name: 'Biträdesavtal',
    version: '2026-10-13',
    path: '/bitradesavtal',
    file: 'bitradesavtal.md',
  },
};
